import { createAction, props } from '@ngrx/store';
import { InvoiceDoc } from '../_models/invoiceDoc';

// Action types
export const loadInvoiceDocs = createAction('[InvoiceDoc] Load InvoiceDocs');
export const loadInvoiceDocsSuccess = createAction(
  '[InvoiceDoc] Load InvoiceDocs Success',
  props<{ invoiceDocs: InvoiceDoc[] }>()
);
export const loadInvoiceDocsFailure = createAction(
  '[InvoiceDoc] Load InvoiceDocs Failure',
  props<{ error: any }>()
);

export const addInvoiceDoc = createAction(
  '[InvoiceDoc] Add InvoiceDoc',
  props<{ invoiceDoc: InvoiceDoc }>()
);
export const addInvoiceDocSuccess = createAction(
  '[InvoiceDoc] Add InvoiceDoc Success',
  props<{ invoiceDoc: InvoiceDoc }>()
);
export const addInvoiceDocFailure = createAction(
  '[InvoiceDoc] Add InvoiceDoc Failure',
  props<{ error: any }>()
);

export const updateInvoiceDoc = createAction(
  '[InvoiceDoc] Update InvoiceDoc',
  props<{ invoiceDoc: InvoiceDoc }>()
);
export const updateInvoiceDocSuccess = createAction(
  '[InvoiceDoc] Update InvoiceDoc Success',
  props<{ invoiceDoc: InvoiceDoc }>()
);
export const updateInvoiceDocFailure = createAction(
  '[InvoiceDoc] Update InvoiceDoc Failure',
  props<{ error: any }>()
);

export const deleteInvoiceDoc = createAction(
  '[InvoiceDoc] Delete InvoiceDoc',
  props<{ id: number }>()
);
export const deleteInvoiceDocSuccess = createAction(
  '[InvoiceDoc] Delete InvoiceDoc Success',
  props<{ id: number }>()
);
export const deleteInvoiceDocFailure = createAction(
  '[InvoiceDoc] Delete InvoiceDoc Failure',
  props<{ error: any }>()
);
